import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from 'react';

import styles from './DragContext.module.css';
import DragManager from './DragManager';

export interface DragContextValue {
  getDragManager: () => DragManager;
}

const DragContext = createContext<DragContextValue>({
  getDragManager: () => {
    throw new Error('DragContext not set up!');
  },
});

export function DragContextProvider({ children }: PropsWithChildren<{}>) {
  const managerRef = useRef(new DragManager(styles.dragging));

  useEffect(() => {
    const manager = managerRef.current;
    manager.init();
    return () => manager.close();
  }, []);

  const getDragManager = useCallback(() => managerRef.current, []);

  return <DragContext.Provider value={{ getDragManager }}>{children}</DragContext.Provider>;
}

export function useDragContext() {
  return useContext(DragContext);
}
